module.exports = __webpack_public_path__ + "img/login-img5.a5ea44a0.png";